import 'slick-carousel/slick/slick'

export default $(()=>{

    let $relatedProduct = $('.related-products');
    let carouselOptions = {
        slidesToShow: 4,
        speed: 1000,
        slidesToScroll: 4,
        dots: true,
        appendArrows: '.slider-nav',
        appendDots: '.slider-nav',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }

        ]
    };

    $relatedProduct.find('.carousel').slick(carouselOptions);


});